/**
 *
 * Asynchronously loads the component for SelectAdapter
 *
 */

import { lazyLoad } from 'utils/loadable';

export const SelectAdapter = lazyLoad(
  () => import('./index'),
  module => module.SelectAdapter,
);
